import { transport } from 'config/transport';

export function callApiNoiTruGetNumberOfStudents(congDoanId, year) {
    return transport.get(`/noitru/${congDoanId}/thuchi/soluonghocsinh`, { params: { year } });
}
